const mutations = {
  SET_LOADING(state, key) {
    state.loading[key] = true
  },
  CLEAR_LOADING(state, key) {
    state.loading[key] = false
  },
  SET_SEARCH_RESULT(state, payload) {
    state.searchResult = payload
  },
  SET_ADVERTISER_LIST(state, payload) {
    state.advertiserList = payload
  },
  SET_AGENCY_LIST(state, payload) {
    state.agencyList = payload
  },
  CLEAR_AGENCY_LIST(state) {
    state.agencyList = []
  },
  SET_AGENCY_ACCOUNT_LIST(state, payload) {
    state.agencyAccountList = payload
  },
  CLEAR_AGENCY_ACCOUNT_LIST(state) {
    state.agencyAccountList = []
  },
  SET_KEYWORD(state, keyword) {
    state.keyword = keyword
  },
  SET_PAGE_NO(state, pageNo) {
    state.pageNo = pageNo
  },
  SET_PAGE_SIZE(state, pageSize) {
    state.pageSize = pageSize
  },
  SET_SORT_OPRIONS(state, sortOptions) {
    state.sortOptions = sortOptions
  },
}

export default mutations
